import script from "./ParentProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentProduct.vue?vue&type=script&setup=true&lang=js"

import "./ParentProduct.vue?vue&type=style&index=0&id=7c186079&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Desktop/HMM-Projects/posvue-version-one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c186079"]])

export default __exports__